import { RoutePath } from "#utils/route";
import { NetworkCalculationResults } from "#routes/organization/networks/[networkId]/detail/calculation-result";

export const NetworkCalculationResultRoute = NetworkCalculationResults.concat(
  new RoutePath<"period">({
    path: "/:period/details",
    title: "Calculation Result",
  })
);
